import { isValidPhoneNumber } from "react-phone-number-input";
import {
  boolean, object, string, ValidationError,
} from "yup";

export const registerValidation = object().shape({
  company: string()
    .required()
    .trim()
    .notOneOf(
      [
        "system",
        "sys",
        "portal",
        "lumian",
        "digiterra",
      ],
      "companyInvalid",
    )
    .max(64, "companyInvalid"),
  name: string().matches(/^\S+$/, "whiteSpace").required(),
  surname: string().matches(/^\S+$/, "whiteSpace").required(),
  email: string().trim().email()
    .required(),
  phone: string()
    .test("phone-validation", (value, context) => {
      if (!value) {
        return true;
      }
      return isValidPhoneNumber(value) || new ValidationError("phone", value, context.path);
    }),
  pdpa: boolean().required()
    .oneOf([true], "pdpaRequired"),
});
